import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { AuthSessionService } from '../../services/auth-session/auth-session.service';
import { EcbCartLine, EcbCourseKind, UnifiedCartService } from '../../services/unified-cart/unified-cart.service';

@Component({ selector: 'app-cart', templateUrl: './cart.component.html', styleUrls: ['./cart.component.scss'] })
export class CartComponent implements OnInit, OnDestroy {
  items: EcbCartLine[] = [];
  editing: EcbCartLine | null = null;
  processing = false;
  confirming = false;
  confirmedForm = { firstName: '', lastName: '', email: '', mobile: '', companyName: '' };
  error = '';
  private sub?: Subscription;
  form = { firstName: '', lastName: '', email: '', mobile: '', companyName: '' };
  constructor(public cart: UnifiedCartService, private session: AuthSessionService) {}

  ngOnInit(): void {
    this.sub = this.cart.items$.subscribe(items => this.items = items);
    const user = this.session.getCurrentUser();
    if (user) {
      this.form.email = user.email || '';
      const parts = (user.fullName || '').trim().split(/\s+/);
      this.form.firstName = parts.shift() || '';
      this.form.lastName = parts.join(' ');
    }
  }
  ngOnDestroy(): void { this.sub?.unsubscribe(); }
  get shortCourses(): EcbCartLine[] { return this.items.filter(i => i.kind === 'SHORT'); }
  get qualifications(): EcbCartLine[] { return this.items.filter(i => i.kind === 'QUALIFICATION'); }
  get subtotal(): number { return this.cart.subtotal; }
  get currency(): string { return this.items[0]?.currency || 'AUD'; }
  remove(kind: EcbCourseKind, id: number): void { this.cart.remove(kind, id); }
  checkout(): void {
    this.error = '';
    if (!this.items.length || this.processing) return;
    const firstName = this.form.firstName.trim(), lastName = this.form.lastName.trim(), email = this.form.email.trim();
    if (!firstName || !lastName || !/^\S+@\S+\.\S+$/.test(email)) {
      this.error = 'Please enter your first name, last name and a valid email address.'; return;
    }
    this.confirmedForm = { firstName, lastName, email, mobile: this.form.mobile.trim(), companyName: this.form.companyName.trim() };
    this.confirming = true;
  }
  closeConfirmation(): void { if (!this.processing) this.confirming = false; }
  confirmAndPay(): void {
    if (!this.confirming || this.processing || !this.items.length) return;
    this.error = '';
    this.processing = true;
    this.cart.checkout({ ...this.confirmedForm,
      items: this.items.map(i => ({ kind: i.kind, courseId: i.courseId, occurrenceId: i.occurrenceId }))
    }).subscribe({
      next: result => {
        if (!result?.checkoutUrl || !/^https:\/\/checkout\.stripe\.com\//i.test(result.checkoutUrl)) {
          this.processing = false;
          this.confirming = false;
          this.error = 'Unable to start secure checkout. Please try again.'; return;
        }
        // Stripe hosts all card details, never collect or store them in ECB Angular.
        window.location.assign(result.checkoutUrl);
      },
      error: response => {
        this.processing = false;
        this.confirming = false;
        this.error = response?.error?.message || 'Checkout could not start. Please review your dates and try again.';
      }
    });
  }
}
